import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const ArticleIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uef42'}</MuiIcon>
    );
}
